'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Default = require('./Default.scss');

var _Default2 = _interopRequireDefault(_Default);

var _Upload = require('../../components/upload/Upload');

var _Upload2 = _interopRequireDefault(_Upload);

var _Modal = require('../../components/modal/Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _TextEdit = require('../../components/textEdit/TextEdit');

var _TextEdit2 = _interopRequireDefault(_TextEdit);

var _ColorPicker = require('../../components/colorPicker/ColorPicker');

var _ColorPicker2 = _interopRequireDefault(_ColorPicker);

var _CustomCKEditor = require('../../components/customCKEditor/CustomCKEditor');

var _CustomCKEditor2 = _interopRequireDefault(_CustomCKEditor);

var _email = require('redux/modules/email');

var _email2 = _interopRequireDefault(_email);

var _reactRedux = require('react-redux');

var _useBasename = require('../../../../helpers/useBasename');

var _useBasename2 = _interopRequireDefault(_useBasename);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var md = {
    build: require('react-icons/lib/md/edit'),
    back: require('react-icons/lib/md/arrow-back')
};

var Default = (_dec = (0, _reactRedux.connect)(function (state) {
    return {};
}, {
    createTemplate: _email2.default
}), _dec(_class = function (_React$Component) {
    (0, _inherits3.default)(Default, _React$Component);

    function Default(props) {
        var _this2 = this;

        (0, _classCallCheck3.default)(this, Default);

        var _this = (0, _possibleConstructorReturn3.default)(this, (Default.__proto__ || (0, _getPrototypeOf2.default)(Default)).call(this, props));

        _this.validationCompleted = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
            var keys, flag;
            return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            keys = (0, _keys2.default)(_this.state.template);
                            flag = true;
                            _context.next = 4;
                            return keys.map(function (key) {
                                if (_this.state.template[key] === null) {
                                    flag = false;
                                }
                            });

                        case 4:
                            if (flag === true) {
                                // 5d5c7b68548135cd3a3b800d esto es el layout uid
                                _this.props.setDataToSend(_this.state.template);
                            }

                            _this.props.completeComponentFunction(flag);

                        case 6:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.actionChange = function (propertyName, type) {
            var component = _this.state.components.map(function (element) {
                if (element.name === type) return element.component;
            });
            _this.setState({ modal: !_this.state.modal.modal, propertyEdit: propertyName, component: component });
        };

        _this.modifyDataTemplate = function (valueAsigned) {
            var key = _this.state.propertyEdit;
            _this.setState({ template: (0, _extends4.default)({}, _this.state.template, (0, _defineProperty3.default)({}, key, valueAsigned)) }, function () {
                _this.validationCompleted();
            });
        };

        _this.renderModal = function () {
            if (_this.state.modal) {

                return _react2.default.createElement(
                    _Modal2.default,
                    { close: _this.closeModal,
                        modifyDataTemplate: _this.modifyDataTemplate,
                        validation: _this.validationCompleted,
                        propertyEdit: _this.state.propertyEdit,
                        preservData: _this.state.template },
                    _this.state.component
                );
            }
            return _react2.default.createElement('div', null);
        };

        _this.closeModal = function () {
            _this.setState({ 'modal': false });
        };

        _this.getInputData = function (change, type) {
            if (type == 'name') {
                _this.setState({ template: (0, _extends4.default)({}, _this.state.template, { name: change.target.value }) }, function () {
                    _this.validationCompleted();
                });
            } else if (type == 'subject') {
                _this.setState({ template: (0, _extends4.default)({}, _this.state.template, { subject: change.target.value }) });
            }
            _this.forceUpdate();
            _this.validationCompleted();
        };

        _this.matadelay = function (change, type) {
            if (type == 'title') {
                _this.setState({ template: (0, _extends4.default)({}, _this.state.template, { title: change.target.value }) }, function () {
                    _this.forceUpdate();
                    _this.validationCompleted();
                });
            }
            _this.forceUpdate();

            _this.validationCompleted();
        };

        _this.changeHeader = function (data) {
            _this.setState({ template: (0, _extends4.default)({}, _this.state.template, { title: data }) });
            _this.forceUpdate();
            _this.validationCompleted();
        };

        _this.state = {
            account_uid: _this.props.account_uid,
            template: {
                logo: _this.props.accountUI.image,
                title: null,
                bgHeader: _this.props.accountUI.background,
                content: null,
                contentFooter: null,
                bgFooter: _this.props.accountUI.background,
                name: null,
                subject: _this.props.draggedFileData !== undefined ? _this.props.draggedFileData.subject : null
            },
            variables: _this.props.draggedFileData !== undefined ? _this.props.draggedFileData.variableForTemplate : [],
            modal: false,
            propertyEdit: '',
            components: [{ name: 'img', component: _react2.default.createElement(_Upload2.default, { setData: _this.modifyDataTemplate }) }, { name: 'text', component: _react2.default.createElement(_TextEdit2.default, { setData: _this.modifyDataTemplate }) }, { name: 'color', component: _react2.default.createElement(_ColorPicker2.default, { setData: _this.modifyDataTemplate }) }],
            component: null
        };
        return _this;
    }

    (0, _createClass3.default)(Default, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.duplicate && this.props.duplicate !== null) {
                var newData = this.props.duplicate.properties;
                newData['name'] = this.props.duplicate.name;
                newData['subject'] = this.props.draggedFileData ? this.props.draggedFileData.subject : this.props.duplicate.subject;
                this.setState({ template: newData });
            }
        }
    }, {
        key: 'Atras',
        value: function Atras() {
            window.location.reload();
        }
    }, {
        key: 'changeBody',
        value: function changeBody(data) {
            this.setState({ template: (0, _extends4.default)({}, this.state.template, { content: data }) });
            this.forceUpdate();
            this.validationCompleted();
        }
    }, {
        key: 'changeFooter',
        value: function changeFooter(data) {
            this.setState({ template: (0, _extends4.default)({}, this.state.template, { contentFooter: data }) });
            this.forceUpdate();
            this.validationCompleted();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return [_react2.default.createElement(
                'div',
                { className: _Default2.default.inputHeader },
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('input', { type: 'text', placeholder: 'Nombre de la plantilla',
                        value: this.state.template.name,
                        onChange: function onChange(change) {
                            return _this3.getInputData(change, 'name');
                        },
                        style: { marginLeft: '38%' } })
                ),
                _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement('input', { type: 'text', placeholder: 'Asunto del correo',
                        value: this.state.template.subject,
                        onChange: function onChange(change) {
                            return _this3.getInputData(change, 'subject');
                        } })
                )
            ), _react2.default.createElement(
                'header',
                { className: _Default2.default.header, style: { backgroundColor: this.state.template.bgHeader } },
                _react2.default.createElement(
                    'div',
                    { className: _Default2.default.componentEdit, style: { width: '100%' } },
                    _react2.default.createElement(
                        'div',
                        { className: _Default2.default.logoSqDef },
                        _react2.default.createElement(
                            'div',
                            { calssName: _Default2.default.logo },
                            _react2.default.createElement('img', { src: this.state.template.logo === undefined ? '/static/mailLogo.png' : this.state.template.logo, alt: 'logo',
                                className: _Default2.default.imgLogo })
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _Default2.default.logoChSqDef },
                            _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/emailLogoWhite.svg'), className: _Default2.default.imgIcon,
                                onClick: function onClick() {
                                    _this3.actionChange('logo', 'img');
                                } })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Default2.default.componentEdit, style: {
                            width: '100%', height: '85%', top: '7px', right: '2px',
                            overflowY: 'auto', border: 'dashed rgba(255, 255, 255, 0.21)'
                        } },
                    _react2.default.createElement(_CustomCKEditor2.default, { type: 'title',
                        data: this.state.template.title,
                        parentCallBack: function parentCallBack(data) {
                            return _this3.changeHeader(data);
                        },
                        variables: this.state.variables })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Default2.default.componentEdit, style: { width: '100%', right: '4px' } },
                    _react2.default.createElement(
                        'div',
                        { className: _Default2.default.changeFillSqDef },
                        _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/colorPickerEmailWhite.svg'), className: _Default2.default.headerColor,
                            onClick: function onClick() {
                                _this3.actionChange('bgHeader', 'color');
                            } })
                    )
                )
            ), _react2.default.createElement(
                'content',
                { className: _Default2.default.textEdit },
                _react2.default.createElement(
                    'div',
                    { className: _Default2.default.editorColumn },
                    _react2.default.createElement(_CustomCKEditor2.default, { type: 'body',
                        data: this.state.template.content,
                        parentCallBack: function parentCallBack(data) {
                            return _this3.changeBody(data);
                        },
                        variables: this.state.variables })
                )
            ), _react2.default.createElement(
                'footer',
                { className: _Default2.default.footer, style: { backgroundColor: this.state.template.bgFooter } },
                _react2.default.createElement(
                    'div',
                    { className: _Default2.default.footTxt },
                    _react2.default.createElement(_CustomCKEditor2.default, { type: 'footer',
                        data: this.state.template.contentFooter,
                        parentCallBack: function parentCallBack(data) {
                            return _this3.changeFooter(data);
                        },
                        variables: this.state.variables })
                ),
                _react2.default.createElement(
                    'div',
                    { className: _Default2.default.footFill },
                    _react2.default.createElement('img', { src: (0, _useBasename2.default)('/static/colorPickerEmailWhite.svg'), className: _Default2.default.footerColor,
                        onClick: function onClick() {
                            _this3.actionChange('bgFooter', 'color');
                        } })
                )
            ), _react2.default.createElement(md.back, { className: _Default2.default.left, onClick: function onClick() {
                    return _this3.Atras();
                } }), _react2.default.createElement(
                'span',
                null,
                this.renderModal()
            )];
        }
    }]);
    return Default;
}(_react2.default.Component)) || _class);
exports.default = Default;
module.exports = exports['default'];